<template>
  <a-modal
    :centered="true"
    :confirmLoading="loading"
    :destroyOnClose="true"
    :title="$t('button.editStorageRoom')"
    :visible="visible"
    width="75%"
    @cancel="handleCancel"
    @ok="handleOk">
    <a-spin :spinning="loading">
      <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="storageRoom" :rules="rules" :wrapper-col="wrapperCol" style="margin-left: -2%;margin-right: 2%">
        <a-row>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.storageRoomNo')" prop="no">
              <a-input v-model="storageRoom.no"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.storageRoomName')" prop="name">
              <a-input v-model="storageRoom.name"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.storageRoomType')" prop="storageRoomType">
              <a-select v-model="storageRoom.storageRoomType" :options="storageRoomTypes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.storageEnvironment')" prop="storageEnvironment">
              <a-select v-model="storageRoom.storageEnvironment" :options="storageEnvironments" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.tag')" prop="tag">
              <a-input v-model="storageRoom.tag"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.exchangeStorageRoom')" prop="exchangeStorageRoom">
              <a-input v-model="storageRoom.exchangeStorageRoom.name" allowClear @dblclick="()=>this.$refs.storageRoomModal.open()" @pressEnter="()=>this.$refs.storageRoomModal.open()"/>
              <storage-room-modal ref="storageRoomModal" @change="(sr)=>storageRoom.exchangeStorageRoom=sr.length===0?new Identifier():sr[0]"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.containerType')" prop="containerType">
              <a-input-search readOnly
                              :value="getStrings(storageRoom.containerTypes, 'name')"
                              @dblclick="()=>this.$refs.containerTypeModal.open()"
                              @pressEnter="()=>this.$refs.containerTypeModal.open()"
                              @search="()=>this.$refs.containerTypeModal.open()"/>
              <container-type-modal ref="containerTypeModal"
                                    select-type="checkbox"
                                    @change="(containerTypes)=>{storageRoom.containerTypes=containerTypes}"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.floor')" prop="floor">
              <a-input v-model="storageRoom.floor"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.reservedLocations')" prop="reservedLocations">
              <a-input-number v-model="storageRoom.reservedLocations" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.numberOfPickingOrder')" prop="numberOfPickingOrder">
              <a-input-number v-model="storageRoom.numberOfPickingOrder" :min="1" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.numberOfBarcode')" prop="numberOfBarcode">
              <a-input-number v-model="storageRoom.numberOfBarcode" :min="1" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4">
            <a-form-model-item :label="$t('business.label.available')" :label-col="wrapperCol" :wrapper-col="labelCol" prop="available">
              <vxe-switch v-model="storageRoom.available" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('business.label.automatic')" :label-col="wrapperCol" :wrapper-col="labelCol" prop="automatic">
              <vxe-switch v-model="storageRoom.automatic" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('business.label.allocable')" :label-col="wrapperCol" :wrapper-col="labelCol" prop="allocable">
              <vxe-switch v-model="storageRoom.allocable" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('business.label.aggregate')" :label-col="wrapperCol" :wrapper-col="labelCol" prop="aggregate">
              <vxe-switch v-model="storageRoom.aggregate" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('business.label.weighable')" :label-col="wrapperCol" :wrapper-col="labelCol" prop="weighable">
              <vxe-switch v-model="storageRoom.weighable" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4">
            <a-form-model-item :label="$t('business.label.checkable')" :label-col="wrapperCol" :wrapper-col="labelCol" prop="checkable">
              <vxe-switch v-model="storageRoom.checkable" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('business.label.separable')" :label-col="wrapperCol" :wrapper-col="labelCol" prop="separable">
              <vxe-switch v-model="storageRoom.separable" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('business.label.serialNumberManagement')" :label-col="wrapperCol" :wrapper-col="labelCol" prop="serialNumberManagement">
              <vxe-switch v-model="storageRoom.serialNumberManagement" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('business.label.caseOnly')" :label-col="wrapperCol" :wrapper-col="labelCol" prop="caseOnly">
              <vxe-switch v-model="storageRoom.caseOnly" size="mini"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>
<script>
import Vue from 'vue'
import { save } from '@/api/Api'
import { WAREHOUSE } from '@/store/mutation-types'
import { getStrings } from '@/utils/util'
import StorerModal from '@/views/modal/StorerModal.vue'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import ContainerTypeModal from '@/views/modal/ContainerTypeModal.vue'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import { Identifier } from '@/api/dto/Identifier'

export default {
  name: 'StorageRoomEdit',
  computed: {
    Identifier() {
      return Identifier
    }
  },
  components: { ContainerTypeModal, StorerModal, StorageRoomModal },
  data() {
    return {
      visible: false,
      loading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      storageRoom: new StorageRoom(),
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        no: [
          { required: true, message: '请输入编号' }
        ],
        name: [
          { required: true, message: '请输入名称' }
        ],
        storageRoomType: [
          { required: true, message: '请选择库房类型' }
        ],
        storageEnvironment: [
          { required: true, message: '请选择存储环境' }
        ],
        floor: [
          { required: true, message: '请输入楼层' }
        ]
      }
    }
  },
  props: {
    storageRoomTypes: {
      type: Array,
      default: []
    },
    storageEnvironments: {
      type: Array,
      default: []
    }
  },
  methods: {
    getStrings,
    add() {
      this.edit()
    },
    edit(record) {
      this.visible = true
      this.storageRoom = new StorageRoom(record)
    },
    save() {
      this.loading = true
      const storageRoom = this.storageRoom.toJSONObject()
      storageRoom.warehouse = this.warehouse
      save('storageRoomPersister', storageRoom).then(res => {
        if (res.success) {
          this.storageRoom = new StorageRoom(res.result)
          this.$message.success('保存成功')
          this.$emit('success')
          this.handleCancel()
        }
      }).finally(() => this.loading = false)
    },
    handleOk() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.save()
        }
      })
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>